<template>
  <v-app>
    <home-app-bar />

    <home-view />

    <home-footer />
  </v-app>
</template>

<script>
export default {
  name: "HomeWrapper",

  components: {
    HomeAppBar: () => import("@/views/home/layouts/HomeAppBar.vue"),
    HomeFooter: () => import("@/views/home/layouts/Footer"),
    HomeView: () => import("@/views/home/layouts/View"),
  },
};
</script>
